import { Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { RoomContext } from "App/context";
import Typography from "common/components/Typography";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

type SoloBanSideProps = {
  value: "Player 1" | "Player 2";
  onChange: (side: "Player 1" | "Player 2") => void;
};

/*
  Solo : camp qui reçoit les bans pré-draft. Un seul camp a droit aux bans d'équilibrage et aux
  bans joker, d'où un choix unique pour les deux familles. Changer de camp puis bannir efface
  les bans posés pour l'autre camp (le serveur fait respecter la règle).
*/
const SoloBanSide = ({ value, onChange }: SoloBanSideProps) => {
  const { t } = useTranslation();
  const { player1, player2 } = useContext(RoomContext);

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      <Typography size="sm">{t("Bans au nom de :")}</Typography>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={(_, side: "Player 1" | "Player 2" | null) =>
          side && onChange(side)
        }
      >
        {(
          [
            ["Player 1", "player1", player1?.pseudo],
            ["Player 2", "player2", player2?.pseudo],
          ] as const
        ).map(([side, color, pseudo]) => (
          <ToggleButton
            key={side}
            value={side}
            sx={{
              textTransform: "none",
              maxWidth: "9rem",
              "&.Mui-selected": {
                color: ({ palette }) => palette.common[color].text,
              },
            }}
          >
            <Typography
              size="sm"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              {pseudo}
            </Typography>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
};

export default SoloBanSide;
